module.exports = __webpack_public_path__ + "static/web-painting-5-afdf186a1b2fcaaebfaa851ef2538ecb.jpg";